module.exports = __webpack_public_path__ + "img/29b)(Hofgarten)Montage von über 50 Luxuswohnungen.jpg";